import { ApolloLink } from '@apollo/client';

export function VersionLink(onUpdateVersion) {
  return new ApolloLink((operation, forward) =>
    forward(operation).map((data) => {
      const dutchieVersion = operation.getContext().response.headers.get('x-dutchie-version');

      if (dutchieVersion) {
        onUpdateVersion(dutchieVersion);
      }

      return data;
    })
  );
}
